<template>
  <div class="order-item">
    <div class="generate-order-container container">
      <e-search
        :count="100"
        :data="filterInfo.data"
        :field-list="filterInfo.fieldList"
        :list-type-info="listTypeInfo"
        :width="filterInfo.width"
        @handleFilter="handleFilter"
        @handleReset="reset"
      ></e-search>
    </div>
    <div class="container">
      <div class="generate-order-top">
         <eui-btn
          type="text"
          :icon="isSort ? 'eicon-arrow-up' : 'eicon-arrow-down'"
          @click="sortChange"
          >按接收时间排序</eui-btn
        >
        <!-- <eui-btn
          v-show="isSort"
          type="text"
          icon="eicon-arrow-down"
          @click="sortChange"
          >按接收时间排序</eui-btn
        > -->
<!--        <div class="generate-order-top-left">-->
<!--          &lt;!&ndash; <div class="generate-order-top-left-input">-->
<!--            <div>采购申请明细</div>-->
<!--          </div> &ndash;&gt;-->
<!--          <div class="generate-order-top-left-sort" @click="sortChange">-->
<!--            <div>按接收时间排序</div>-->
<!--            <img-->
<!--              v-show="!isSort"-->
<!--              src="../../../../../assets/img/purchase/up copy.png"-->
<!--              alt=""-->
<!--            />-->
<!--            <img-->
<!--              v-show="isSort"-->
<!--              src="../../../../../assets/img/purchase/down copy.png"-->
<!--              alt=""-->
<!--            />-->
<!--          </div>-->
<!--        </div>-->
      </div>
      <!-- <div
        v-for="(item, index) in myPurchaseRequestData"
        :key="index"
        class="generate-order-main"
      >
        <div class="order-item">
          <div class="order-item-main">
            <div class="order-item-left">
              {{ index + 1 }}
            </div>
            <div class="order-item-middle">
              <ul>
                <li>
                  <div class="text" :class="{ isActive: checked }">
                    采购申请号：
                  </div>
                  <div class="text-value">{{ item.requestno }}</div>
                </li>
                <li>
                  <div class="text" :class="{ isActive: checked }">
                    商品行号：
                  </div>
                  <div class="text-value">{{ item.itemno }}</div>
                </li>
                <li>
                  <div class="text" :class="{ isActive: checked }">
                    商品名称：
                  </div>
                  <div class="text-value text-value-number ellipsis">
                    {{ item.prodname }}
                  </div>
                </li>
                <li class="li-width-196">
                  <div class="text" :class="{ isActive: checked }">
                    商品规格：
                  </div>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="item.spec"
                    placement="top"
                    :manual="item.spec && item.spec.length >= 12 ? false : true"
                  >
                    <div class="text-value ellipsis text-value-number150">
                      {{ item.spec }}
                    </div>
                  </el-tooltip>
                </li>

                <li>
                  <div class="text" :class="{ isActive: checked }">
                    期望到货时间：
                  </div>
                  <div class="text-value">{{ item.arriveTimeTxt }}</div>
                </li>

                <li>
                  <div class="text text100" :class="{ isActive: checked }">
                    平台接收时间：
                  </div>
                  <e-tooltip :content="item.createTime" :set-length="12" />
                </li>

                <li>
                  <div class="text" :class="{ isActive: checked }">
                    应采数量：
                  </div>
                  <div class="text-value">{{ item.intqty }}</div>
                </li>

                <li>
                  <div class="text" :class="{ isActive: checked }">
                    剩余应采数量：
                  </div>
                  <div class="text-value ellipsis">
                    {{
                      item.remainingQuantity != null
                        ? item.remainingQuantity
                        : item.intqty
                    }}
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div v-if="noDataFlag" class="no-data">
        <p>贵公司当前暂无采购申请跟踪</p>
       
      </div> -->
      <div>
        <e-table
          :table-data="myPurchaseRequestData"
          :table-label="tableLabel"
          :index-show="true"
        >
          <template #remainingQuantity="slot">
            <div class="text-value ellipsis">
              {{
                slot.scope.row.remainingQuantity != null
                  ? slot.scope.row.remainingQuantity
                  : slot.scope.row.intqty
              }}
            </div>
          </template>
        </e-table>
      </div>
      <div class="pagination-box">
        <el-pagination
          style="margin-top: 20px"
          :pager-count="5"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="formInline.page"
          :total="formInline.total"
          :page-size.sync="formInline.limit"
          prev-text="上一页"
          next-text="下一页"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/modules/projectA/api/purchase';
import eTable from '@/modules/projectA/components/common/e-table-list.vue';
import eSearch from '../../../components/common/e-search';
import eTooltip from '../../../components/common/e-tooltip';

export default {
  name: 'OrderItem',
  components: { eSearch, eTooltip, eTable },
  data() {
    return {
      filterInfo: {
        data: {
          requestNo: null,
          saveStatus: null,
          prodname: null,
          apimaterNo: null,
          itemno: null,
        },
        fieldList: [
          { label: '采购申请号', type: 'input', value: 'requestNo' },
          {
            label: '商品是否保存',
            type: 'select',
            value: 'saveStatus',
            list: 'saveStatusList',
          },
          { label: '项目编号', type: 'input', value: 'itemno' },
          { label: '商品名称', type: 'input', value: 'prodname' },
          { label: '企业物料编码', type: 'input', value: 'apimaterNo' },
        ],
        width: {
          labelWidth: 130,
          itemWidth: 160,
        },
      },
      listTypeInfo: {
        saveStatusList: [
          { id: null, name: '全部' },
          { id: 0, name: '是' },
          { id: 1, name: '否' },
        ],
      },
      tableLabel: [
        {
          label: '采购申请号',
          align: 'center',
          param: 'requestno',
        },

        {
          label: '商品行号',
          align: 'center',
          param: 'itemno',
        },
        {
          label: '商品名称',
          align: 'center',
          param: 'prodname',
        },
        {
          label: '商品规格',
          align: 'center',
          param: 'spec',
        },
        {
          label: '期望到货时间',
          align: 'center',
          param: 'arriveTimeTxt',
        },
        {
          label: '平台接收时间',
          align: 'center',
          param: 'createTime',
        },
        {
          label: '应采数量',
          align: 'center',
          param: 'intqty',
        },
        {
          label: '剩余应采数量',
          align: 'center',
          slot: 'remainingQuantity',
        },
      ],
      noDataFlag: false,
      isSort: false,
      checked: false,
      options: [
        {
          value: null,
          label: '全部',
        },
        {
          value: '0',
          label: '是',
        },
        {
          value: '1',
          label: '否',
        },
      ],
      myPurchaseRequestData: [],
      pageClick: true,
      formInline: {
        requestNo: null,
        saveStatus: null,
        prodname: null,
        apimaterNo: null,
        itemno: null,
        createTimeSort: 'DESC',
        limit: 10, // 每页条数
        page: 1, // 页码
        total: 0,
        clickQuery: null,
        track: 1,
      },
    };
  },
  mounted() {
    this.pageClick = false;
    this.queryPurchaseRequestList();
  },
  methods: {
    toSelect() {
      this.$router.push({ path: '/' });
    },
    handleCurrentChange(val) {
      this.formInline.page = val;
      this.pageClick = false;
      this.queryPurchaseRequestList();
    },
    handleSizeChange(val) {
      this.formInline.page = 1;
      this.formInline.limit = val;
      this.pageClick = false;
      this.queryPurchaseRequestList();
    },
    handleFilter(val) {
      this.formInline.requestNo = val.requestNo;
      this.formInline.saveStatus = val.saveStatus;
      this.formInline.prodname = val.prodname;
      this.formInline.apimaterNo = val.apimaterNo;
      this.formInline.itemno = val.itemno;
      this.formInline.page = 1;
      this.queryPurchaseRequestList();
    },
    reset() {
      this.formInline = {
        requestNo: null,
        saveStatus: null,
        prodname: null,
        createTimeSort: 'DESC',
        limit: 10, // 每页条数
        page: 1, //
        total: 0,
        clickQuery: null,
        track: 1,
      };
      this.queryPurchaseRequestList();
    },
    sortChange() {
      this.isSort = !this.isSort;
      this.queryPurchaseRequestList();
    },
    async queryPurchaseRequestList() {
      if (this.isSort) {
        this.formInline.createTimeSort = 'DESC';
      } else {
        this.formInline.createTimeSort = 'ASC';
      }
      if (this.pageClick) {
        this.formInline.clickQuery = 1;
        this.formInline.page = 1;
      } else {
        this.formInline.clickQuery = 0;
      }
      const res = await Api.queryPurchaseRequestList(this.formInline);
      if (res.code == '200') {
        this.formInline.total = res.data.totalCount;
        this.myPurchaseRequestData = res.data.purchaseRequestListVOs || [];
        if (
          !this.myPurchaseRequestData ||
          this.myPurchaseRequestData.length == 0
        ) {
          this.noDataFlag = true;
        } else {
          this.noDataFlag = false;
        }
      }
      this.pageClick = true;
    },
    // 删除已选采购申请
    async deleteSelectedPurchaseRequest() {
      const res = Api.deletePurchaseRequest();
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/css/theme.scss';
.order-item {
  padding: 10px;
  .generate-order-container {
    border: 1px solid #d9d9d9;
    box-sizing: border-box;
    margin-bottom: 20px;
    .pagination {
      display: flex;
      justify-content: flex-end;
    }
    ::v-deep .el-form {
      .el-form-item__label {
        color: #333;
      }
      .el-form-item {
        input::-webkit-input-placeholder {
          color: #999;
        }
        input::-moz-input-placeholder {
          color: #999;
        }
        input::-ms-input-placeholder {
          color: #999;
        }
      }
    }
    .button {
      display: flex;
      justify-content: center;
      margin-bottom: 10px;
      margin-top: 6px;
      .btn {
        width: 80px;
        text-align: center;
        height: 30px;
        line-height: 30px;
        cursor: pointer;
      }

      .reset-btn {
        width: 80px;
        height: 30px;
        border: 1px solid #dcdfe6;
        color: #333;
        margin-right: 30px;
        font-size: 14px;
        &:hover,
        :active {
          background-color: #bedbff;
          border: 1px solid #bedbff;
          color: #2587ff;
        }
      }
      .submit-btn {
        font-size: 14px;
        color: #2587ff;
        border: 1px solid #2587ff;
        &:hover,
        :active {
          background-color: #e8efff;
        }
      }
    }
    ::v-deep .el-form {
      .el-form-item {
        margin-bottom: 2px;

        .el-form-item__content {
          input {
            width: 200px;
            height: 30px;
            line-height: 30px;
          }

          .el-range-input {
            width: 80px;
          }

          .el-range-separator {
            width: 30px;
          }

          .el-date-editor {
            width: 200px;
          }

          .el-button:focus,
          .el-button:hover {
            color: #333333;
            background-color: transparent;
          }

          .el-checkbox-group {
            margin-left: 70px;

            .is-checked {
              .el-checkbox__inner {
                background-color: #ffa900;
              }

              .el-checkbox__inner::after {
                border-color: #333333;
              }
            }

            .is-checked + .el-checkbox__label {
              color: #333333;
            }
          }

          .el-date-editor {
            height: 30px;

            i:nth-child(1) {
              display: none;
            }

            .el-range__close-icon {
              line-height: 22px;
            }

            input {
              height: 25px;
            }

            .el-range-separator {
              height: 25px;
              line-height: 25px;
            }
          }

          .el-button {
            padding: 9px 27px;
          }

          .reset-btn {
            margin: 0 20px 0 80px;
          }
        }
      }
    }
  }
  ::v-deep.el-input__inner {
    border-radius: 0;
    color: #333;
  }
  .generate-order-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 40px;
    padding: 10px 20px;
    border: 1px solid $border-color;
    margin-bottom: 10px;
    box-sizing: border-box;

    ::v-deep .el-checkbox__label {
      font-weight: bold;
      color: #333333;
    }

    .generate-order-top-left {
      display: flex;
      align-items: center;

      .generate-order-top-left-input {
        ::v-deep .el-checkbox {
          .is-checked {
            .el-checkbox__inner {
              background-color: $button-background-color;
            }

            .el-checkbox__inner::after {
              border-color: #333333;
            }
          }

          .is-checked + .el-checkbox__label {
            color: #333333;
          }
        }
      }

      .generate-order-top-left-sort {
        display: flex;
        align-items: center;
        cursor: pointer;

        div {
          margin-left: 40px;
          margin-right: 10px;
          font-size: 14px;
        }

        img {
          width: 13px;
          height: 14px;
        }
      }
    }

    .generate-order-top-right {
      display: flex;
      align-items: center;
      cursor: pointer;

      div {
        margin-left: 10px;
      }
    }
  }

  .is-active {
    background-color: #f4f7ff;
  }
  .no-data {
    text-align: center;
    img {
      margin-top: 60px;
      width: 204px;
      height: 124px;
    }
    p {
      margin-top: 10px;
      color: #333;
      font-size: 16px;
      span {
        color: #2587ff;
        cursor: pointer;
      }
    }
  }
  .generate-order-main {
    .order-item {
      display: flex;
      justify-content: space-between;
      height: 90px;
      padding: 0 20px;
      border: 1px solid $border-color;
      box-sizing: border-box;

      .order-item-main {
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        .order-item-left {
          margin-top: 20px;
          box-sizing: border-box;
          line-height: 48px;
          height: 48px;
          // border-right: 1px solid #D9D9D9;
          width: 40px;
          padding-right: 20px;
          text-align: center;
          position: relative;
          &::after {
            content: '';
            position: absolute;
            right: 0;
            width: 1px;
            background: #d9d9d9;
            height: 100%;
          }
        }

        .order-item-middle {
          ul {
            display: flex;
            flex-wrap: wrap;
            width: 920px;

            li {
              display: flex;
              width: 220px;

              &:nth-of-type(4n + 1) {
                margin-left: 20px;
              }

              .text {
                color: #333;
              }

              .text86 {
                width: 100px;
              }

              .text70 {
                width: 82px;
              }

              .text75 {
                width: 75px;
              }

              .text85 {
                width: 85px;
              }
              .text99 {
                width: 114px;
              }
              .text100 {
                width: 107px;
              }

              .text115 {
                width: 115px;
              }

              .isActive {
                color: #333;
              }

              .text-value {
                color: #333;
              }
              .t-132 {
                width: 132px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }

              .text-value-number {
                width: 80px;
              }

              .text-value-number150 {
                width: 150px;
              }
            }

            li:nth-child(-n + 4) {
              padding: 15px 0;
              box-sizing: border-box;
            }

            .li-width-196 {
              width: 240px;
            }
          }
        }
      }

      .order-item-right {
        display: flex;
        align-items: center;
        justify-content: flex-end;

        .selectBtn {
          width: 80px;
          height: 30px;
          line-height: 26px;
          color: #ea9200;
          text-align: center;
          border: 2px solid #ffa900;
          background: #fff5c7;
          box-sizing: border-box;
          cursor: pointer;
        }
      }
    }

    .isMainActive {
      background: #f4f7ff;
    }
  }
  .pagination-box {
    text-align: right;
  }
}
</style>
